export const GET_INSIGHT_MESSAGE_PENDING = 'GET_INSIGHT_MESSAGE_PENDING'
export const GET_INSIGHT_MESSAGE_SUCCESSFUL = 'GET_INSIGHT_MESSAGE_SUCCESSFUL'
export const GET_INSIGHT_MESSAGE_ERROR = 'GET_INSIGHT_MESSAGE_ERROR'
export const LOAD_INSIGHT_MESSAGES_SUCCESSFUL = 'LOAD_INSIGHT_MESSAGES_SUCCESSFUL'
export const LOAD_INSIGHT_MESSAGES_PENDING = 'LOAD_INSIGHT_MESSAGES_PENDING'


